export default __webpack_public_path__ + "static/media/YAS0140.34I-27625_-26218_0.bf806474.jpg";